var JabberExtension = /** @class */ (function () {
    function JabberExtension() {
    }
    JabberExtension.adminMessage = function (client) {
        var properties = client.stanzas.define({
            name: 'properties',
            element: 'properties',
            namespace: 'http://www.jivesoftware.com/xmlns/xmpp/properties',
        });
        var property = client.stanzas.define({
            name: 'property',
            element: 'property',
            fields: {
                name: client.stanzas.utils.textSub('', 'name'),
                value: client.stanzas.utils.textSub('', 'value'),
            }
        });
        var value = client.stanzas.define({
            name: 'value',
            element: 'value',
            fields: {
                type: client.stanzas.utils.attribute('type'),
                text: client.stanzas.utils.text()
            }
        });
        client.stanzas.withMessage(function (Message) {
            client.stanzas.extend(property, value, 'property');
            client.stanzas.extend(properties, property, 'properties');
            client.stanzas.extend(Message, properties);
        });
    };
    return JabberExtension;
}());
export { JabberExtension };
//# sourceMappingURL=jabber.extension.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/utils/jabber.extension.js
// module id = 960
// module chunks = 14